import {
    Button,
    Grid,
    Typography,
    AppBar,
    IconButton,
    Toolbar,
    Box,
    Paper
} from '@mui/material';

import React, { PropsWithChildren, useEffect } from 'react';

// const Pic: React.FC<{ src: string }> = ({ src }) => {
//     return <Grid size={2}>
//         <Box sx={{ p: 1 }}>
//             <img src={src} width={140} height={140} />
//         </Box>
//     </Grid>
// }

const Pic: React.FC<PropsWithChildren<{ src?: string }>> = ({ children, src }) => {
    return <Grid size={2}>
        <Paper sx={{
            p: 0,
            width: 160,
            height: 160,
            overflow: 'hidden',
            alignItems: 'center'
        }}>
            {children == null ? <img src={src} width={160} height={160} /> : <Grid
                container
                alignItems="center"
                justifyContent="center"
                height="100%"
                sx={src == null ? {
                    backgroundColor: theme => theme.palette.grey[200]
                } : {
                    backgroundImage: `url("${src}")`,
                    backgroundSize: '160px 160px'
                }}
            >{children}</Grid>}
        </Paper>
    </Grid>
}

const Text: React.FC<{ title: string, text: string }> = ({ title, text }) => {
    return <Grid size={10}>
        <Typography variant='h6' sx={{ p: 1, pb: 0 }}>{title}</Typography>
        <Typography sx={{ p: 1 }}>{text}</Typography>
    </Grid>
}

const LandingCard: React.FC<PropsWithChildren<{ title: string, text: string, src?: string, mirror?: boolean }>> = ({ children, title, text, src, mirror = false }) => {
    return (
        <Grid>
            <Grid
                container
                direction="row"
            >
                {
                    mirror ?
                        <>
                            <Text
                                title={title}
                                text={text}
                            />
                            {children == null ? <Pic src={src} /> : <Pic src={src}>{children}</Pic>}
                        </>
                        :
                        <>
                            {children == null ? <Pic src={src} /> : <Pic src={src}>{children}</Pic>}
                            <Text
                                title={title}
                                text={text}
                            />
                        </>
                }
            </Grid>
        </Grid>)
}

export default LandingCard
